import {
  Box,
  CircularProgress,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  styled,
  useTheme,
} from '@mui/material';
import {
  AddIcon,
  ArrowBackIosIcon,
  ArrowForwardIosIcon,
  ArrowRightAltIcon,
  ExportIcon,
  FilterAltIcon,
  SearchIcon,
  SyncAltIcon,
} from '../../../../../../assets/Icons';
import { useEffect, useRef, useState } from 'react';
import debounce from 'lodash.debounce';
import CustomCard from '../../../../../../components/shared/CustomCard';
import CustomButton from '../../../../../../components/shared/CustomButton';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeSortAscRequest,
  getAllNewDataTransaction,
  getTransactionRequest,
  getTransactionRequestIsLoading,
  getTransactionRequestSortAsc,
  getTransactionRequestSortIn,
  getTransactionRequestTotalItem,
} from '../../../../../../store/transaction/request/dataTableRequest';
import dayjs from 'dayjs';
import { changePageTransaction } from '../../../../../../store/Routing/transactionRouting';
import {
  changeIdTransactionRequest,
  changeUserEmployee,
} from '../../../../../../store/transaction/request/detailTransactionRequest';

const CustomTableCells = styled(TableCell)({
  color: '#000000',
  fontWeight: 500,
  fontSize: '0.75rem',
  textTransform: 'capitalize',
});

const TableRequestTransaction = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isLoading = useSelector(getTransactionRequestIsLoading);
  const tableDatas = useSelector(getTransactionRequest);

  // !  search
  const [search, setSearch] = useState('');
  const [purchaseKeyword, setTransactionKeyword] = useState('');

  const debounceOnChange = useRef(
    debounce((value) => {
      setTransactionKeyword(value);
    }, 1000)
  ).current;

  // ! sorting
  const sortInTable = useSelector(getTransactionRequestSortIn);
  const sortAscTable = useSelector(getTransactionRequestSortAsc);
  const [sortTable, setSortTable] = useState('');
  const [asc, setAsc] = useState('asc');

  // ! pagination
  const pageSizeList = [5, 10, 15, 20, 25];
  const [pageSizeTable, setPageSizeTable] = useState(pageSizeList[0]);
  const [currentPageTable, setCurrentPageTable] = useState(1);
  const totalItemTable = useSelector(getTransactionRequestTotalItem);

  //! -------------- TOOLBAR -------------------
  const [isFilter, setIsFilter] = useState(false);
  const toolbar = (
    <Box sx={{ display: 'flex', gap: 2, flexDirection: 'row-reverse' }}>
      {/* addd */}
      <CustomButton
        sx={{
          bgcolor: '#51B15C',
          color: '#ffffff',
          borderRadius: '8px',
          '&:hover': {
            bgcolor: '#51B15C',
            color: '#ffffff',
          },
          fontSize: '0.875rem',
          px: 2,
        }}
        startIcon={<AddIcon sx={{ width: '14px', color: '#FFFFFF' }} />}
        onClick={() => {
          handleAddRequest();
        }}
      >
        Add
      </CustomButton>
      {/* export */}
      <CustomCard
        sx={{
          p: '10px 20px',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          cursor: 'pointer',
        }}
        onClick={() => setIsFilter(!isFilter)}
      >
        <ExportIcon sx={{ fontSize: '20px' }} />
        <Typography
          sx={{ fontSize: '14px', fontWeight: 500, color: '#000000' }}
        >
          Export
        </Typography>
      </CustomCard>
      {/* //* Filter */}
      <CustomCard
        sx={{
          p: '10px 20px',
          borderRadius: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          cursor: 'pointer',
        }}
        onClick={() => setIsFilter(!isFilter)}
      >
        <FilterAltIcon sx={{ fontSize: '20px' }} />
        <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#000' }}>
          Filter
        </Typography>
      </CustomCard>
      {/* <DialogFilterTransaction {...{ isFilter, setIsFilter }} /> */}
    </Box>
  );

  // ! ----------------------------- API ----------------
  useEffect(() => {
    let datas = {};
    datas.page = currentPageTable;
    datas.pageSize = Number(pageSizeTable);
    datas.search = purchaseKeyword;
    datas.sortSku = sortTable !== 'sortSku' ? '' : asc;
    datas.sortForm = sortTable !== 'sortFrom' ? '' : asc;
    datas.sortTo = sortTable !== 'sortTo' ? '' : asc;
    datas.sortDate = sortTable !== 'sortDate' ? '' : asc;
    datas.status = ['baru'];
    dispatch(getAllNewDataTransaction(datas));
  }, [currentPageTable, pageSizeTable, purchaseKeyword, sortTable, asc]);

  // !----------------- Handler --------------------------

  const handleAddRequest = () => {
    dispatch(changePageTransaction('addRequest'));
  };

  const handlePageSize = (e) => {
    setPageSizeTable(e.target.value);
  };

  const handleForwardArrow = () => {
    setCurrentPageTable(
      currentPageTable >= Math.ceil(totalItemTable / pageSizeTable)
        ? currentPageTable
        : currentPageTable + 1
    );
  };

  const handleBackArrow = () => {
    setCurrentPageTable(
      currentPageTable <= 1 ? currentPageTable : currentPageTable - 1
    );
  };

  const handleInputCurrentPage = (event) => {
    if (event.target.value >= Math.ceil(totalItemTable / pageSizeTable)) {
      setCurrentPageTable(Math.ceil(totalItemTable / pageSizeTable));
    } else if (event.target.value <= 1) {
      setCurrentPageTable(1);
    } else {
      setCurrentPageTable(event.target.value);
    }
  };

  const handleClickRow = (id, userEmploye) => {
    dispatch(changeIdTransactionRequest(id));
    dispatch(changePageTransaction('detailRequestTransaction'));

    dispatch(changeUserEmployee(userEmploye));
  };

  return (
    <Box sx={{ p: 2 }}>
      <Grid container columnSpacing={4} alignItems="center">
        <Grid item xs>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>
              Request List
            </Typography>
            <TextField
              placeholder={'Search'}
              size="small"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                debounceOnChange(e.target.value);
              }}
              sx={{
                width: '250px',
                '& .MuiOutlinedInput-root': {
                  paddingLeft: '6px',
                  fontSize: '0.875rem',
                },
                bgcolor: '#FAFAFA',
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ width: '18px' }} />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Grid>

        <Grid item xs="auto">
          {toolbar}
        </Grid>
      </Grid>
      {/* fetch data */}
      <Table sx={{ mt: 1 }}>
        <TableHead>
          <TableRow sx={{ bgcolor: '#FAFAFA' }}>
            <CustomTableCells>No.</CustomTableCells>
            <CustomTableCells>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                  cursor: 'pointer',
                }}
                // onClick={() => {
                //   setSortTable('sortInvoice');
                //   dispatch(changeSortAscRequest(!sortAscTable));
                //   if (sortAscTable === true) {
                //     setAsc('asc');
                //   } else {
                //     setAsc('desc');
                //   }
                // }}
              >
                <Typography
                  sx={{ fontSize: '12px', fontWeight: '500', mr: '2px' }}
                >
                  ID
                </Typography>
                {sortTable === 'id' ? (
                  sortAscTable ? (
                    <ArrowRightAltIcon
                      sx={{
                        fontSize: '12px',
                        transform: 'rotate(90deg)',
                        color: theme.palette.primary.main,
                      }}
                    />
                  ) : (
                    <ArrowRightAltIcon
                      sx={{
                        fontSize: '12px',
                        transform: 'rotate(270deg)',
                        color: theme.palette.primary.main,
                      }}
                    />
                  )
                ) : (
                  <SyncAltIcon
                    sx={{
                      fontSize: '12px',
                      transform: 'rotate(90deg)',
                      color: '#9E9D9D',
                    }}
                  />
                )}
              </Box>
            </CustomTableCells>
            <CustomTableCells>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setSortTable('sortAmount');
                  dispatch(changeSortAscRequest(!sortAscTable));
                  if (sortAscTable === true) {
                    setAsc('asc');
                  } else {
                    setAsc('desc');
                  }
                }}
              >
                <Typography
                  sx={{ fontSize: '12px', fontWeight: '500', mr: '2px' }}
                >
                  SKU
                </Typography>
                {sortTable === 'sortAmount' ? (
                  sortAscTable ? (
                    <ArrowRightAltIcon
                      sx={{
                        fontSize: '12px',
                        transform: 'rotate(90deg)',
                        color: theme.palette.primary.main,
                      }}
                    />
                  ) : (
                    <ArrowRightAltIcon
                      sx={{
                        fontSize: '12px',
                        transform: 'rotate(270deg)',
                        color: theme.palette.primary.main,
                      }}
                    />
                  )
                ) : (
                  <SyncAltIcon
                    sx={{
                      fontSize: '12px',
                      transform: 'rotate(90deg)',
                      color: '#9E9D9D',
                    }}
                  />
                )}
              </Box>
            </CustomTableCells>

            <CustomTableCells>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setSortTable('sortFrom');
                  dispatch(changeSortAscRequest(!sortAscTable));
                  if (sortAscTable === true) {
                    setAsc('asc');
                  } else {
                    setAsc('desc');
                  }
                }}
              >
                <Typography
                  sx={{ fontSize: '12px', fontWeight: '500', mr: '2px' }}
                >
                  From
                </Typography>
                {sortTable === 'sortFrom' ? (
                  sortAscTable ? (
                    <ArrowRightAltIcon
                      sx={{
                        fontSize: '12px',
                        transform: 'rotate(90deg)',
                        color: theme.palette.primary.main,
                      }}
                    />
                  ) : (
                    <ArrowRightAltIcon
                      sx={{
                        fontSize: '12px',
                        transform: 'rotate(270deg)',
                        color: theme.palette.primary.main,
                      }}
                    />
                  )
                ) : (
                  <SyncAltIcon
                    sx={{
                      fontSize: '12px',
                      transform: 'rotate(90deg)',
                      color: '#9E9D9D',
                    }}
                  />
                )}
              </Box>
            </CustomTableCells>

            <CustomTableCells>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setSortTable('sortTo');
                  dispatch(changeSortAscRequest(!sortAscTable));
                  if (sortAscTable === true) {
                    setAsc('asc');
                  } else {
                    setAsc('desc');
                  }
                }}
              >
                <Typography
                  sx={{ fontSize: '12px', fontWeight: '500', mr: '2px' }}
                >
                  To
                </Typography>
                {sortTable === 'sortTo' ? (
                  sortAscTable ? (
                    <ArrowRightAltIcon
                      sx={{
                        fontSize: '12px',
                        transform: 'rotate(90deg)',
                        color: theme.palette.primary.main,
                      }}
                    />
                  ) : (
                    <ArrowRightAltIcon
                      sx={{
                        fontSize: '12px',
                        transform: 'rotate(270deg)',
                        color: theme.palette.primary.main,
                      }}
                    />
                  )
                ) : (
                  <SyncAltIcon
                    sx={{
                      fontSize: '12px',
                      transform: 'rotate(90deg)',
                      color: '#9E9D9D',
                    }}
                  />
                )}
              </Box>
            </CustomTableCells>

            <CustomTableCells>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setSortTable('sortDate');
                  dispatch(changeSortAscRequest(!sortAscTable));
                  if (sortAscTable === true) {
                    setAsc('asc');
                  } else {
                    setAsc('desc');
                  }
                }}
              >
                <Typography
                  sx={{ fontSize: '12px', fontWeight: '500', mr: '2px' }}
                >
                  Date
                </Typography>
                {sortTable === 'sortDate' ? (
                  sortAscTable ? (
                    <ArrowRightAltIcon
                      sx={{
                        fontSize: '12px',
                        transform: 'rotate(90deg)',
                        color: theme.palette.primary.main,
                      }}
                    />
                  ) : (
                    <ArrowRightAltIcon
                      sx={{
                        fontSize: '12px',
                        transform: 'rotate(270deg)',
                        color: theme.palette.primary.main,
                      }}
                    />
                  )
                ) : (
                  <SyncAltIcon
                    sx={{
                      fontSize: '12px',
                      transform: 'rotate(90deg)',
                      color: '#9E9D9D',
                    }}
                  />
                )}
              </Box>
            </CustomTableCells>
          </TableRow>
        </TableHead>

        {!isLoading && (
          <TableBody>
            {tableDatas?.map((tableData, index) => (
              <TableRow
                key={index}
                sx={{ cursor: 'pointer' }}
                onClick={() => {
                  handleClickRow(tableData?.idOrders, tableData?.userEmploye);
                }}
              >
                <CustomTableCells sx={{ width: '40px' }}>
                  {(currentPageTable - 1) * pageSizeTable + (index + 1)}
                </CustomTableCells>
                <CustomTableCells>
                  TR {tableData.idOrders ? tableData.idOrders : '-'}
                </CustomTableCells>
                <CustomTableCells>
                  {tableData.sku ? tableData.sku : '-'}
                </CustomTableCells>

                <CustomTableCells>
                  {tableData.lokasiPemberi ? tableData.namaPemberi : '-'}
                </CustomTableCells>

                <CustomTableCells>
                  {tableData.lokasiTujuan ? tableData.namaTujuan : '-'}
                </CustomTableCells>

                <CustomTableCells>
                  {tableData.tglOrder
                    ? dayjs(tableData.tglOrder).format('DD/MMM/YY')
                    : '-'}
                </CustomTableCells>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>

      {/* loading data */}
      {isLoading && (
        <Box
          sx={{
            height: `${50 * pageSizeTable}px`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      )}

      {/* pagination */}
      <Grid
        container
        direction="row"
        coloumn={12}
        alignItems="center"
        sx={{ mt: '30px' }}
      >
        <Grid item xs={6} sx={{ fontSize: '14px', fontWeight: '500' }}>
          Showing {currentPageTable * pageSizeTable - (pageSizeTable - 1)} to{' '}
          {currentPageTable * pageSizeTable >= totalItemTable
            ? totalItemTable
            : currentPageTable * pageSizeTable}{' '}
          of {totalItemTable} entries
        </Grid>
        <Grid
          container
          item
          direction="row"
          xs={6}
          justifyContent="flex-end"
          alignItems="center"
        >
          <Grid item sx={{ fontSize: '14px', fontWeight: '500' }}>
            Rows Per Page :
            <Select
              value={pageSizeTable}
              variant="filled"
              onChange={handlePageSize}
              sx={{
                fontSize: '14px',
                lineHeight: '-1px',
                '.MuiFilledInput-input': {
                  paddingTop: '7.5px',
                  paddingBottom: '7.5px',
                  paddingLeft: '10px',
                  paddingRight: '0',
                  borderRadius: '5px',
                },
                '&:before': {
                  borderRadius: '5px',
                  borderBottom: 0,
                },
                '&:after': {
                  borderRadius: '5px',
                  borderBottom: 0,
                },
                borderRadius: '5px',
                marginLeft: '8px',
              }}
            >
              {pageSizeList.map((item, index) => (
                <MenuItem value={item} key={index}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item sx={{ ml: '35px' }}>
            <Box sx={{ display: 'inline', mr: '10px' }}>
              <IconButton sx={{ p: 0 }} onClick={handleBackArrow}>
                <ArrowBackIosIcon sx={{ color: '#323232', width: '16px' }} />
              </IconButton>
              <Box sx={{ display: 'inline', mr: '20px' }}>
                <OutlinedInput
                  variant="outlined"
                  type="number"
                  value={currentPageTable}
                  onChange={handleInputCurrentPage}
                  sx={{
                    border: '1px solid #9E9D9D',
                    width: '36px',
                    borderRadius: '5px',
                    textAlign: 'center',
                    '& .MuiOutlinedInput-input': {
                      padding: '5px 8px 5px 8px',
                      fontSize: '0.875rem',
                      boxShadow: 'none',
                      textAlign: 'center',
                      fontWeight: 600,
                      width: '25px',
                    },
                    '&:before': {
                      borderRadius: '5px',
                      borderBottom: 0,
                    },
                    '&:after': {
                      borderRadius: '5px',
                      borderBottom: 0,
                    },
                    '&.Mui-focused': {
                      '& .MuiOutlinedInput-notchedOutline': {
                        boxShadow: 'none',
                      },
                    },
                  }}
                />
              </Box>
              <Box
                sx={{
                  display: 'inline',
                  fontWeight: '600',
                  fontSize: '14px',
                  color: '#9E9D9D',
                }}
              >
                of {Math.ceil(totalItemTable / pageSizeTable)}
              </Box>
              <Box sx={{ display: 'inline', ml: '10px' }}>
                <IconButton sx={{ p: 0 }} onClick={handleForwardArrow}>
                  <ArrowForwardIosIcon
                    sx={{ color: '#323232', width: '16px' }}
                  />
                </IconButton>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
export default TableRequestTransaction;
